import styled from 'styled-components'

export const DynamicDatesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  p {
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    color: ${props => props.theme.colors.text.default};
  }

  input {
    max-width: 25px;
    margin-bottom: 0;
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  //to remove input helperText
  div > div:last-child {
    display: none;
  }
`
